import {DeepPartial} from 'redux';
import {EventLog, Maybe} from '../graphql/generated/types';
import {TIARA_OBJECT_PROPS_KEY} from './constants';
import {TrackEventObject} from './TrackEventObject.interface';

export function putTiaraObjectProps(
  obj?: DeepPartial<TrackEventObject | Maybe<EventLog>>
) {
  if (!obj) {
    return {};
  }
  return {
    [TIARA_OBJECT_PROPS_KEY]: JSON.stringify(obj),
  };
}
